// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: "Arial", sans-serif;
  background-color: #f0f0f0;
  margin: 0;
  padding: 0;
  overflow: hidden; /* [EXPERT] Previene scroll en el body */
}

.App {
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden; /* [EXPERT] Bloquea el layout al alto de la ventana */
}
header {
  background-color: #333;
  color: white;
  padding: 10px 20px; /* Reducimos el tamaño */
  display: flex; /* Flexbox para posicionar los elementos */
  justify-content: space-between; /* Espacio entre el título y los botones */
  align-items: left; /* Alinea verticalmente */
}

/*fondo de los botones de cambio de idioma al poner puntero de mouse*/
button:hover {
  background-color: #a7a5a5;
}
/*estilo para el cuadro donde estan los botones de navegacion*/
nav {
  display: flex;
  justify-content: left;
  background-color: #928a8a;
}
nav a {
  color: white;
  padding: 14px 20px;
  text-decoration: none;
  text-align: center;
}
nav a:hover {
  background-color: #ddd;
  color: black;
}
.menu-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 50px;
}
.menu-item {
  background-color: #4f66eb;
  color: white;
  padding: 15px;
  margin: 10px;
  border-radius: 8px;
  transition: transform 0.3s ease;
}
.menu-item:hover {
  transform: scale(1.1);
  background-color: #3f51b5;
}
.content {
  padding: 20px;
  text-align: center;
}
.content h2 {
  font-size: 2em;
}
.chinese-text {
  font-size: 1.5em;
  color: #5f615f;
}
.submenu {
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  background-color: #333;
  list-style-type: none;
  padding: 0;
  margin: 0;
  min-width: 160px;
}
.submenu li a {
  color: white;
  padding: 10px;
  text-decoration: none;
  display: block;
}
.submenu li a:hover {
  background-color: #ddd;
  color: black;
}
.menu-item:hover .submenu {
  display: block;
}

form {
  display: flex;
  flex-direction: column; /* Asegura que los campos se apilen verticalmente */
  margin: auto; /* Centra el formulario dentro de su contenedor */
  padding: 20px;
  background-color: white;
  max-width: 400px; /* Ancho máximo del formulario */
}

input {
  margin-bottom: 30px; /* espacio entre cada imput o combobox */
  padding: 5px; /* Espaciado interno */
  width: 100%; /*Asegura que sean lo suficientemente amplios */
  border-radius: 5px;
}

/* LABEL FLOTANTE*/
.p-float-label label {
  left: 0.2rem; /* Ajusta la posición horizontal */

  transition: all 0.2s ease-in-out; /* Suaviza la animación */
}

/* Ajusta el estilo del label cuando está flotando */
.p-float-label .p-inputtext:focus + label,
.p-float-label .p-inputtext:not(:placeholder-shown) + label {
  top: -0.45rem; /* Ajusta la posición vertical del texto flotante */
  font-size: 0.75rem; /* Reduce el tamaño del texto flotante */
  color: #007ad9; /* Cambia el color del texto flotante si deseas */
}

/****************************** para los dropdown*********/

/* Bordes redondeados para los Dropdown */
.p-dropdown {
  border-radius: 10px; /* Bordes redondeados */
  padding: 1px; /* Espaciado interno */
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1); /* Sombra opcional */
  transition: all 0.2s ease-in-out; /* Suaviza los cambios visuales */
  width: 100%; /* Asegura que los Dropdowns ocupen todo el espacio disponible */
  margin-bottom: 20px; /* Espacio inferior para separar del siguiente elemento */
}

/* Espaciado adicional entre etiquetas y dropdowns */
label {
  margin-bottom: 4px; /* Espacio entre el label y el dropdown */
  font-size: 0.75rem; /* Ajusta el tamaño de las etiquetas si lo deseas */
  text-align: left; /* Alinea los labels a la derecha */
  color: #007ad9;
}

/* esto esta en el DIV de cada campo / Contenedor general para cada campo */
.field-container {
  display: flex;
  flex-direction: column; /* Asegura que los elementos se apilen verticalmente */
  margin-bottom: 2px; /* Espacio adicional entre cada grupo de campos */
  position: relative; /* Permite posicionar los mensajes de error */
}

/* Ajuste del mensaje de error */
.p-error {
  color: red; /* Color del mensaje */
  font-size: 0.8rem; /* Tamaño más pequeño */
  position: relative; /* Cambia de absolute a relative */
  align-self: flex-end; /* Asegura que esté alineado al inicio o al final */
}

.label-container {
  display: flex; /* Alinea los elementos horizontalmente */
  justify-content: space-between; /* Deja espacio entre el label y el error */
  align-items: center; /* Asegura que estén verticalmente alineados */
  margin-bottom: 2px; /* Espacio entre el label/error y el campo */
}

/*****************ESTILO PARA MENSAJES TOAST DE ERROR******************/
.p-toast.p-toast-top-center {
  position: fixed !important;
  top: 10px !important;
  left: 50% !important;
  transform: translateX(-50%) !important;
  z-index: 9999; /* Asegura que esté sobre otros elementos */
}

/****************ESTILO PARA EL DIALOG************************************************/

.p-confirm-dialog {
  border-radius: 12px; /* Redondear bordes */
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2); /* Sombra */
}

.p-confirm-dialog .p-confirm-dialog-icon {
  background-color: #00bcd4; /* Fondo del icono */
  color: #ffffff; /* Color del icono */
  border-radius: 50%; /* Icono circular */
  padding: 1rem;
}

.p-confirm-dialog-message {
  font-size: 1rem; /* Tamaño del texto */
  color: #333333; /* Color del mensaje */
}

.p-confirm-dialog-footer .p-button-primary {
  background-color: #007bff; /* Color del botón "Save" */
  border: none;
}

.p-confirm-dialog-footer .p-button-outlined {
  color: #007bff; /* Color del texto del botón "Cancel" */
  border-color: #007bff;
}

/* [EXPERT_SEC]: Estilo de Tarjeta para el Paginador */
.p-paginator {
  background-color: #ffffff !important;
  border: 1px solid #e0e0e0 !important;
  border-radius: 12px !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08) !important;
  margin: 1rem auto !important;
  padding: 0.8rem 1.5rem !important;
  width: fit-content !important;
  min-width: 95%;
  justify-content: space-between !important; /* Separa los botones del reporte */
}

/* Ajustes de botones del paginador */
.p-paginator .p-paginator-pages .p-paginator-page,
.p-paginator .p-link {
  border-radius: 8px !important;
  min-width: 2.5rem !important;
  height: 2.5rem !important;
  transition: all 0.2s ease;
}

.p-paginator .p-paginator-pages .p-paginator-page.p-highlight {
  background: #007bff !important;
  color: #ffffff !important;
}

/* Estilo para el reporte "Mostrando X-Y de Z" */
.p-paginator .p-paginator-current {
  font-family: "Inter", sans-serif;
  font-weight: 500;
  color: #666;
  margin-left: auto; /* Empuja el reporte a la derecha */
}

/* Prevención de estiramiento en botones de acción circulares */
.p-button.p-button-rounded {
  flex-shrink: 0 !important;
  align-self: center !important;
}

/* [EXPERT_SEC]: Clase para botones de acción compactos en tablas */
.btn-accion-tabla {
  width: 28px !important;
  height: 28px !important;
  padding: 0 !important;
}

.btn-accion-tabla .p-button-icon {
  font-size: 0.8rem !important;
}

/* [EXPERT_FIX]: Clase helper para reducir el tamaño de los diálogos de confirmación */
/* [EXPERT_FIX]: Clase helper para reducir el tamaño de los diálogos de confirmación 
   Usamos 'body' para aumentar la especificidad y !important para forzar el estilo. 
*/
body .p-dialog.p-confirm-dialog.confirm-dialog-small {
  width: 450px !important;
  min-width: 300px !important;
  max-width: 90vw !important;
  height: auto !important; /* Ajustar altura al contenido */
  min-height: unset !important; /* Eliminar altura mínima predeterminada */
}

/* [EXPERT_FIX]: Ajustar el contenido interno para evitar espacio extra y alinear icono */
body .p-dialog.p-confirm-dialog.confirm-dialog-small .p-dialog-content {
  height: auto !important;
  min-height: unset !important;
  padding-bottom: 0 !important; /* Reducir padding inferior si es necesario */
  display: flex !important;
  align-items: center !important;
  gap: 15px !important;
}

/* [EXPERT_FIX]: Ajuste de margen para cuando el menú está abierto */
.main-content {
  transition: margin-left 0.3s ease;
  margin-left: 0;
  width: 100%;
}

.main-content.menu-open {
  margin-left: 250px; /* Ancho estimado del sidebar */
  width: calc(100% - 250px);
}

/* Asegurar que las tablas de PrimeReact se adapten */
.p-datatable-wrapper {
  overflow-x: auto;
}

@media screen and (max-width: 960px) {
  .main-content.menu-open {
    margin-left: 0;
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/App.css"],"names":[],"mappings":"AAAA;EACE,gCAAgC;EAChC,yBAAyB;EACzB,SAAS;EACT,UAAU;EACV,gBAAgB,EAAE,wCAAwC;AAC5D;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB,EAAE,qDAAqD;AACzE;AACA;EACE,sBAAsB;EACtB,YAAY;EACZ,kBAAkB,EAAE,wBAAwB;EAC5C,aAAa,EAAE,0CAA0C;EACzD,8BAA8B,EAAE,0CAA0C;EAC1E,iBAAiB,EAAE,yBAAyB;AAC9C;;AAEA,qEAAqE;AACrE;EACE,yBAAyB;AAC3B;AACA,8DAA8D;AAC9D;EACE,aAAa;EACb,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;AACjC;AACA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,sBAAsB;EACtB,qBAAqB;EACrB,UAAU;EACV,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB,EAAE,mDAAmD;EAC3E,YAAY,EAAE,iDAAiD;EAC/D,aAAa;EACb,uBAAuB;EACvB,gBAAgB,EAAE,gCAAgC;AACpD;;AAEA;EACE,mBAAmB,EAAE,wCAAwC;EAC7D,YAAY,EAAE,sBAAsB;EACpC,WAAW,EAAE,+CAA+C;EAC5D,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,YAAY,EAAE,kCAAkC;;EAEhD,gCAAgC,EAAE,yBAAyB;AAC7D;;AAEA,oDAAoD;AACpD;;EAEE,aAAa,EAAE,mDAAmD;EAClE,kBAAkB,EAAE,wCAAwC;EAC5D,cAAc,EAAE,iDAAiD;AACnE;;AAEA,0DAA0D;;AAE1D,yCAAyC;AACzC;EACE,mBAAmB,EAAE,uBAAuB;EAC5C,YAAY,EAAE,sBAAsB;EACpC,0CAA0C,EAAE,oBAAoB;EAChE,gCAAgC,EAAE,iCAAiC;EACnE,WAAW,EAAE,gEAAgE;EAC7E,mBAAmB,EAAE,yDAAyD;AAChF;;AAEA,oDAAoD;AACpD;EACE,kBAAkB,EAAE,yCAAyC;EAC7D,kBAAkB,EAAE,mDAAmD;EACvE,gBAAgB,EAAE,mCAAmC;EACrD,cAAc;AAChB;;AAEA,2EAA2E;AAC3E;EACE,aAAa;EACb,sBAAsB,EAAE,sDAAsD;EAC9E,kBAAkB,EAAE,iDAAiD;EACrE,kBAAkB,EAAE,6CAA6C;AACnE;;AAEA,gCAAgC;AAChC;EACE,UAAU,EAAE,sBAAsB;EAClC,iBAAiB,EAAE,uBAAuB;EAC1C,kBAAkB,EAAE,kCAAkC;EACtD,oBAAoB,EAAE,mDAAmD;AAC3E;;AAEA;EACE,aAAa,EAAE,yCAAyC;EACxD,8BAA8B,EAAE,2CAA2C;EAC3E,mBAAmB,EAAE,8CAA8C;EACnE,kBAAkB,EAAE,4CAA4C;AAClE;;AAEA,uEAAuE;AACvE;EACE,0BAA0B;EAC1B,oBAAoB;EACpB,oBAAoB;EACpB,sCAAsC;EACtC,aAAa,EAAE,2CAA2C;AAC5D;;AAEA,sFAAsF;;AAEtF;EACE,mBAAmB,EAAE,qBAAqB;EAC1C,0CAA0C,EAAE,WAAW;AACzD;;AAEA;EACE,yBAAyB,EAAE,oBAAoB;EAC/C,cAAc,EAAE,oBAAoB;EACpC,kBAAkB,EAAE,mBAAmB;EACvC,aAAa;AACf;;AAEA;EACE,eAAe,EAAE,qBAAqB;EACtC,cAAc,EAAE,sBAAsB;AACxC;;AAEA;EACE,yBAAyB,EAAE,2BAA2B;EACtD,YAAY;AACd;;AAEA;EACE,cAAc,EAAE,uCAAuC;EACvD,qBAAqB;AACvB;;AAEA,sDAAsD;AACtD;EACE,oCAAoC;EACpC,oCAAoC;EACpC,8BAA8B;EAC9B,qDAAqD;EACrD,4BAA4B;EAC5B,iCAAiC;EACjC,6BAA6B;EAC7B,cAAc;EACd,yCAAyC,EAAE,mCAAmC;AAChF;;AAEA,qCAAqC;AACrC;;EAEE,6BAA6B;EAC7B,4BAA4B;EAC5B,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA,gDAAgD;AAChD;EACE,gCAAgC;EAChC,gBAAgB;EAChB,WAAW;EACX,iBAAiB,EAAE,mCAAmC;AACxD;;AAEA,+DAA+D;AAC/D;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA,mEAAmE;AACnE;EACE,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,sFAAsF;AACtF;;CAEC;AACD;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,0BAA0B;EAC1B,uBAAuB,EAAE,gCAAgC;EACzD,4BAA4B,EAAE,0CAA0C;AAC1E;;AAEA,yFAAyF;AACzF;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,4BAA4B,EAAE,6CAA6C;EAC3E,wBAAwB;EACxB,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA,oEAAoE;AACpE;EACE,iCAAiC;EACjC,cAAc;EACd,WAAW;AACb;;AAEA;EACE,kBAAkB,EAAE,+BAA+B;EACnD,yBAAyB;AAC3B;;AAEA,qDAAqD;AACrD;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,cAAc;IACd,WAAW;EACb;AACF","sourcesContent":["body {\n  font-family: \"Arial\", sans-serif;\n  background-color: #f0f0f0;\n  margin: 0;\n  padding: 0;\n  overflow: hidden; /* [EXPERT] Previene scroll en el body */\n}\n\n.App {\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden; /* [EXPERT] Bloquea el layout al alto de la ventana */\n}\nheader {\n  background-color: #333;\n  color: white;\n  padding: 10px 20px; /* Reducimos el tamaño */\n  display: flex; /* Flexbox para posicionar los elementos */\n  justify-content: space-between; /* Espacio entre el título y los botones */\n  align-items: left; /* Alinea verticalmente */\n}\n\n/*fondo de los botones de cambio de idioma al poner puntero de mouse*/\nbutton:hover {\n  background-color: #a7a5a5;\n}\n/*estilo para el cuadro donde estan los botones de navegacion*/\nnav {\n  display: flex;\n  justify-content: left;\n  background-color: #928a8a;\n}\nnav a {\n  color: white;\n  padding: 14px 20px;\n  text-decoration: none;\n  text-align: center;\n}\nnav a:hover {\n  background-color: #ddd;\n  color: black;\n}\n.menu-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 50px;\n}\n.menu-item {\n  background-color: #4f66eb;\n  color: white;\n  padding: 15px;\n  margin: 10px;\n  border-radius: 8px;\n  transition: transform 0.3s ease;\n}\n.menu-item:hover {\n  transform: scale(1.1);\n  background-color: #3f51b5;\n}\n.content {\n  padding: 20px;\n  text-align: center;\n}\n.content h2 {\n  font-size: 2em;\n}\n.chinese-text {\n  font-size: 1.5em;\n  color: #5f615f;\n}\n.submenu {\n  display: none;\n  position: absolute;\n  top: 100%;\n  left: 0;\n  background-color: #333;\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n  min-width: 160px;\n}\n.submenu li a {\n  color: white;\n  padding: 10px;\n  text-decoration: none;\n  display: block;\n}\n.submenu li a:hover {\n  background-color: #ddd;\n  color: black;\n}\n.menu-item:hover .submenu {\n  display: block;\n}\n\nform {\n  display: flex;\n  flex-direction: column; /* Asegura que los campos se apilen verticalmente */\n  margin: auto; /* Centra el formulario dentro de su contenedor */\n  padding: 20px;\n  background-color: white;\n  max-width: 400px; /* Ancho máximo del formulario */\n}\n\ninput {\n  margin-bottom: 30px; /* espacio entre cada imput o combobox */\n  padding: 5px; /* Espaciado interno */\n  width: 100%; /*Asegura que sean lo suficientemente amplios */\n  border-radius: 5px;\n}\n\n/* LABEL FLOTANTE*/\n.p-float-label label {\n  left: 0.2rem; /* Ajusta la posición horizontal */\n\n  transition: all 0.2s ease-in-out; /* Suaviza la animación */\n}\n\n/* Ajusta el estilo del label cuando está flotando */\n.p-float-label .p-inputtext:focus + label,\n.p-float-label .p-inputtext:not(:placeholder-shown) + label {\n  top: -0.45rem; /* Ajusta la posición vertical del texto flotante */\n  font-size: 0.75rem; /* Reduce el tamaño del texto flotante */\n  color: #007ad9; /* Cambia el color del texto flotante si deseas */\n}\n\n/****************************** para los dropdown*********/\n\n/* Bordes redondeados para los Dropdown */\n.p-dropdown {\n  border-radius: 10px; /* Bordes redondeados */\n  padding: 1px; /* Espaciado interno */\n  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1); /* Sombra opcional */\n  transition: all 0.2s ease-in-out; /* Suaviza los cambios visuales */\n  width: 100%; /* Asegura que los Dropdowns ocupen todo el espacio disponible */\n  margin-bottom: 20px; /* Espacio inferior para separar del siguiente elemento */\n}\n\n/* Espaciado adicional entre etiquetas y dropdowns */\nlabel {\n  margin-bottom: 4px; /* Espacio entre el label y el dropdown */\n  font-size: 0.75rem; /* Ajusta el tamaño de las etiquetas si lo deseas */\n  text-align: left; /* Alinea los labels a la derecha */\n  color: #007ad9;\n}\n\n/* esto esta en el DIV de cada campo / Contenedor general para cada campo */\n.field-container {\n  display: flex;\n  flex-direction: column; /* Asegura que los elementos se apilen verticalmente */\n  margin-bottom: 2px; /* Espacio adicional entre cada grupo de campos */\n  position: relative; /* Permite posicionar los mensajes de error */\n}\n\n/* Ajuste del mensaje de error */\n.p-error {\n  color: red; /* Color del mensaje */\n  font-size: 0.8rem; /* Tamaño más pequeño */\n  position: relative; /* Cambia de absolute a relative */\n  align-self: flex-end; /* Asegura que esté alineado al inicio o al final */\n}\n\n.label-container {\n  display: flex; /* Alinea los elementos horizontalmente */\n  justify-content: space-between; /* Deja espacio entre el label y el error */\n  align-items: center; /* Asegura que estén verticalmente alineados */\n  margin-bottom: 2px; /* Espacio entre el label/error y el campo */\n}\n\n/*****************ESTILO PARA MENSAJES TOAST DE ERROR******************/\n.p-toast.p-toast-top-center {\n  position: fixed !important;\n  top: 10px !important;\n  left: 50% !important;\n  transform: translateX(-50%) !important;\n  z-index: 9999; /* Asegura que esté sobre otros elementos */\n}\n\n/****************ESTILO PARA EL DIALOG************************************************/\n\n.p-confirm-dialog {\n  border-radius: 12px; /* Redondear bordes */\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2); /* Sombra */\n}\n\n.p-confirm-dialog .p-confirm-dialog-icon {\n  background-color: #00bcd4; /* Fondo del icono */\n  color: #ffffff; /* Color del icono */\n  border-radius: 50%; /* Icono circular */\n  padding: 1rem;\n}\n\n.p-confirm-dialog-message {\n  font-size: 1rem; /* Tamaño del texto */\n  color: #333333; /* Color del mensaje */\n}\n\n.p-confirm-dialog-footer .p-button-primary {\n  background-color: #007bff; /* Color del botón \"Save\" */\n  border: none;\n}\n\n.p-confirm-dialog-footer .p-button-outlined {\n  color: #007bff; /* Color del texto del botón \"Cancel\" */\n  border-color: #007bff;\n}\n\n/* [EXPERT_SEC]: Estilo de Tarjeta para el Paginador */\n.p-paginator {\n  background-color: #ffffff !important;\n  border: 1px solid #e0e0e0 !important;\n  border-radius: 12px !important;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08) !important;\n  margin: 1rem auto !important;\n  padding: 0.8rem 1.5rem !important;\n  width: fit-content !important;\n  min-width: 95%;\n  justify-content: space-between !important; /* Separa los botones del reporte */\n}\n\n/* Ajustes de botones del paginador */\n.p-paginator .p-paginator-pages .p-paginator-page,\n.p-paginator .p-link {\n  border-radius: 8px !important;\n  min-width: 2.5rem !important;\n  height: 2.5rem !important;\n  transition: all 0.2s ease;\n}\n\n.p-paginator .p-paginator-pages .p-paginator-page.p-highlight {\n  background: #007bff !important;\n  color: #ffffff !important;\n}\n\n/* Estilo para el reporte \"Mostrando X-Y de Z\" */\n.p-paginator .p-paginator-current {\n  font-family: \"Inter\", sans-serif;\n  font-weight: 500;\n  color: #666;\n  margin-left: auto; /* Empuja el reporte a la derecha */\n}\n\n/* Prevención de estiramiento en botones de acción circulares */\n.p-button.p-button-rounded {\n  flex-shrink: 0 !important;\n  align-self: center !important;\n}\n\n/* [EXPERT_SEC]: Clase para botones de acción compactos en tablas */\n.btn-accion-tabla {\n  width: 28px !important;\n  height: 28px !important;\n  padding: 0 !important;\n}\n\n.btn-accion-tabla .p-button-icon {\n  font-size: 0.8rem !important;\n}\n\n/* [EXPERT_FIX]: Clase helper para reducir el tamaño de los diálogos de confirmación */\n/* [EXPERT_FIX]: Clase helper para reducir el tamaño de los diálogos de confirmación \n   Usamos 'body' para aumentar la especificidad y !important para forzar el estilo. \n*/\nbody .p-dialog.p-confirm-dialog.confirm-dialog-small {\n  width: 450px !important;\n  min-width: 300px !important;\n  max-width: 90vw !important;\n  height: auto !important; /* Ajustar altura al contenido */\n  min-height: unset !important; /* Eliminar altura mínima predeterminada */\n}\n\n/* [EXPERT_FIX]: Ajustar el contenido interno para evitar espacio extra y alinear icono */\nbody .p-dialog.p-confirm-dialog.confirm-dialog-small .p-dialog-content {\n  height: auto !important;\n  min-height: unset !important;\n  padding-bottom: 0 !important; /* Reducir padding inferior si es necesario */\n  display: flex !important;\n  align-items: center !important;\n  gap: 15px !important;\n}\n\n/* [EXPERT_FIX]: Ajuste de margen para cuando el menú está abierto */\n.main-content {\n  transition: margin-left 0.3s ease;\n  margin-left: 0;\n  width: 100%;\n}\n\n.main-content.menu-open {\n  margin-left: 250px; /* Ancho estimado del sidebar */\n  width: calc(100% - 250px);\n}\n\n/* Asegurar que las tablas de PrimeReact se adapten */\n.p-datatable-wrapper {\n  overflow-x: auto;\n}\n\n@media screen and (max-width: 960px) {\n  .main-content.menu-open {\n    margin-left: 0;\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
